export const isMobileBrowser = (): boolean => {
  return (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    ) ||
    Boolean((navigator.maxTouchPoints && navigator.maxTouchPoints > 2))
  )
}
